export default __webpack_public_path__ + "static/media/office-free-header-logo.4798ff59.svg";